module.exports = __webpack_public_path__ + "static/assets/6bb98d0b86ffb3dcd5aae52f93f2acce.png";